import { render, staticRenderFns } from "./tasklist.vue?vue&type=template&id=7accc64e"
import script from "./tasklist.vue?vue&type=script&lang=js"
export * from "./tasklist.vue?vue&type=script&lang=js"
import style0 from "./tasklist.vue?vue&type=style&index=0&id=7accc64e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports